module.exports = __webpack_public_path__ + "static/media/jgwebcom_n.e93ea68a.svg";